"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    root: 'ms-Slider',
    container: 'ms-Slider-container',
    slideBox: 'ms-Slider-slideBox',
    line: 'ms-Slider-line',
    thumb: 'ms-Slider-thumb',
    activeSection: 'ms-Slider-active',
    inactiveSection: 'ms-Slider-inactive',
    valueLabel: 'ms-Slider-value'
};
exports.getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return ({
        root: [
            classNames.root,
            {},
            className
        ],
        container: [
            classNames.container,
            {}
        ],
        slideBox: [
            classNames.slideBox,
            {}
        ],
        line: [
            classNames.line,
            {}
        ],
        thumb: [
            classNames.thumb,
            {}
        ],
        lineContainer: [
            {}
        ],
        activeSection: [
            classNames.activeSection,
            {}
        ],
        inactiveSection: [
            classNames.inactiveSection,
            {}
        ],
        valueLabel: [
            classNames.valueLabel,
            {}
        ]
    });
};
//# sourceMappingURL=Slider.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Slider/Slider.styles.js
// module id = 1666
// module chunks = 0